/**
 * viewportTablePagination
 *
 * Options-API mixin that sizes a q-table's rows-per-page to fill the available
 * viewport height instead of Quasar's cramped 5-row default. Recomputes on
 * window resize.
 *
 * Usage:
 *   import viewportTablePagination from "@/mixins/viewportTablePagination";
 *   mixins: [viewportTablePagination],
 *   // on the q-table:
 *   ref="viewportTable"
 *   v-model:pagination="pagination"
 *   :rows-per-page-options="rowsPerPageOptions"
 */

const ROW_HEIGHT = 48; // approx height of a q-table body row (px)
// Header row + top control row (search) + pagination footer + a little breathing room.
const TABLE_CHROME = 180;
const MIN_ROWS = 5;

export default {
    data() {
        return {
            pagination: { rowsPerPage: 10 },
            rowsPerPageOptions: [0, 10, 25, 50, 100], // 0 = "All"
        };
    },

    mounted() {
        this.$nextTick(this.updateRowsPerPage);
        window.addEventListener("resize", this.updateRowsPerPage);
    },

    beforeUnmount() {
        window.removeEventListener("resize", this.updateRowsPerPage);
    },

    methods: {
        /** Fit rows-per-page to whatever vertical space is below the table's top. */
        updateRowsPerPage() {
            const el = this.$refs.viewportTable?.$el;
            const top = el ? el.getBoundingClientRect().top : 220;
            const available = window.innerHeight - top - TABLE_CHROME;
            const rows = Math.max(MIN_ROWS, Math.floor(available / ROW_HEIGHT));
            this.pagination = { ...this.pagination, rowsPerPage: rows };
        },
    },
};
